import React from "react";
import ProgressBar from '../progressBar/progressBar.comp.jsx'
import "./currentChallenge.style.scss";

const CurrentChallenge = ({ challenge, acceptedID, navToChall, done, total, onMove, pastDayBoolean, doneBoolean, todayString, lastDayString }) => {
    const title = challenge.title;

    const percent = (done / total) * 100;

    return (
        <div className='current-challenge'>
            <div
                className='current-challenge-image'
                style={{
                    backgroundImage: `url(${challenge.imageURL})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                }}
            >
            </div>
            <div className='current-challenge-info'>
                <div style={{ display: 'flex', alignItems: "center", justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', gap: '8px', alignItems: "center" }}>
                        <h4
                            style={{ textAlign: 'left', margin: 0, cursor: "pointer", color: 'var(--fontblack1)' }}
                            onClick={() => navToChall(acceptedID)}>
                            {title}
                        </h4>
                        <p style={{ fontSize: 'small', margin: 0, fontWeight: 'bold', color: 'var(--fontdarkgrey)' }}>
                            {done} / {total}
                        </p>
                    </div>
                </div>
                <ProgressBar percentageCompletion={percent} />
                {
                    pastDayBoolean && !doneBoolean ? (
                        <p style={{ margin: '0', fontSize: 'small', color: 'grey', textAlign: 'right' }}>
                            This challenge has passed its last scheduled day.
                        </p>
                    ) : null
                }
                {
                    doneBoolean ? (
                        <p
                            style={{ textAlign: "right", margin: '0', fontSize: 'small', fontWeight: 'bold', color: 'grey', cursor: "pointer" }}
                            onClick={() => onMove(acceptedID)}>
                            Done!
                        </p>
                    ) : pastDayBoolean ? (
                        <p
                            style={{ textAlign: "right", margin: '0', fontSize: 'small', fontWeight: 'bold', color: 'grey', cursor: "pointer" }}
                            onClick={() => onMove(acceptedID)}>
                            Move
                        </p>
                    ) : null
                }
                {/* <button onClick={() => console.log(
                    "Past Day: ", pastDayBoolean, 
                    "Done Boolean: ", doneBoolean,
                    "Today String: ", todayString,
                    "Last Day String: ", lastDayString, challenge )}>Print</button> */}
            </div>
        </div>
    );
};


export default CurrentChallenge;